import { NgModule } from '@angular/core';
import { NgInteractionsModule } from '@principle-theorem/ng-interactions';
import { ManagementToolPanelComponent } from '@principle-theorem/ng-management-tools';
import {
  NgPrincipleModule,
  SetupStepBannerComponent,
} from '@principle-theorem/ng-principle';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { MainComponent } from './main/main.component';
import { PortalPageComponent } from './portal-page/portal-page.component';
import { PracticeSelectorCardComponent } from './practice-selector/practice-selector-card/practice-selector-card.component';
import { PracticeSelectorComponent } from './practice-selector/practice-selector.component';

@NgModule({
  imports: [
    NgPrincipleModule,
    NgPrincipleSharedModule,
    NgSharedModule,
    NgInteractionsModule,
    SetupStepBannerComponent,
    ManagementToolPanelComponent,
  ],
  declarations: [
    MainComponent,
    PracticeSelectorComponent,
    PracticeSelectorCardComponent,
    PortalPageComponent,
  ],
  exports: [MainComponent],
})
export class LayoutModule {}
